const MidiPlayer = require("midi.js");
const WebBleMidiTransmitter = require("utils/WebBleMidiTransmitter");

var root = MidiPlayer
class WebBleMidiTransmitterPlugin{

    transmitter = new WebBleMidiTransmitter.default();

    get isAvaliable(){
        return window.navigator.bluetooth != null;
    }
    ctxStartTime = 0;
    connected = false;

    setEventChannel = function(rawData, channelNum) {
        rawData[0] = ( rawData[0] & 0xf0) | channelNum;
        return rawData
    }

    send = function (data, delay) { // set channel volume
        if(!this.connected){
            return
        }
        delay += this.ctxStartTime
        this.transmitter.sendMidiMessage(data, delay * 1000)
    }

    setController = function (event, channel, type, value, delay) {
        if(!this.connected){
            return
        }
        delay += this.ctxStartTime
        //console.log(event)
        let rawdata = event.rawData
        if(root.MidiChannelMapping[channel] != undefined){
            rawdata = this.setEventChannel(rawdata, root.MidiChannelMapping[channel])
        }
        this.transmitter.sendMidiMessage(rawdata, delay * 1000)
    }

    programChange = function (event, channel, program, delay) { // change patch (instrument)
        if(!this.connected){
            return
        }
        delay += this.ctxStartTime
        // console.log(event)
         let rawdata = event.rawData
        if(root.MidiChannelMapping[channel] != undefined){
            rawdata = this.setEventChannel(rawdata, root.MidiChannelMapping[channel])
        }
        this.transmitter.sendMidiMessage(rawdata, delay * 1000)
    }

    pitchBend = function (event, channel, program, delay) { // pitch bend
        if(!this.connected){
            return
        }
        delay += this.ctxStartTime
        // console.log(event)
        let rawdata = event.rawData
        if(root.MidiChannelMapping[channel] != undefined){
            rawdata = this.setEventChannel(rawdata, root.MidiChannelMapping[channel])
        }
        this.transmitter.sendMidiMessage(rawdata, delay * 1000)
    }

    noteOn = function (event,channel, note, velocity, delay) {
        if(!this.connected){
            return
        }
        delay += this.ctxStartTime
        // console.log(event)
        //console.log(event, delay * 1000)
         let rawdata = event.rawData
        if(root.MidiChannelMapping[channel] != undefined){
            rawdata = this.setEventChannel(rawdata, root.MidiChannelMapping[channel])
        }
        this.transmitter.sendMidiMessage(rawdata, delay * 1000)
    }

    noteOff = function (event, channel, note, delay) {
        if(!this.connected){
            return
        }
        delay += this.ctxStartTime
        // console.log(event)
        // console.log(event, delay *--------------------------------------- 1000)
         let rawdata = event.rawData
        if(root.MidiChannelMapping[channel] != undefined){
            rawdata = this.setEventChannel(rawdata, root.MidiChannelMapping[channel])
        }
        this.transmitter.sendMidiMessage(rawdata, delay * 1000)
    }

    chordOn = function (channel, chord, velocity, delay) {
        if(!this.connected){
            return
        }
        if(root.MidiChannelMapping[channel] != undefined){
            channel = root.MidiChannelMapping[channel]
        }
        for (var n = 0; n < chord.length; n++) {
            var note = chord[n]
            this.transmitter.sendMidiMessage([0x90 + channel, note, velocity], delay * 1000)
        }
    }

    chordOff = function (channel, chord, delay) {
        if(!this.connected){
            return
        }
        if(root.MidiChannelMapping[channel] != undefined){
            channel = root.MidiChannelMapping[channel]
        }
        for (var n = 0; n < chord.length; n++) {
            var note = chord[n]
            this.transmitter.sendMidiMessage([0x80 + channel, note, 0], delay * 1000)
        }
    }

    stopAllNotes = function (delay, lookAhead) {
        if(!this.connected){
            return
        }
        delay += this.ctxStartTime

        // console.log(lookAhead)
        for (var channel = 0; channel < 16; channel++) {
            //this.transmitter.sendMidiMessage([0xB0 + channel, 0x7B, 0], 0)
            this.transmitter.sendMidiMessage([0xB0 + channel, 0x7B, 0], delay * 1000)
        }

        this.transmitter.sendMidiMessage([0xFC], delay * 1000)
    }

    onLoopCallBack  =  (interval) => {        
        this.transmitter.bleSend(interval);
    }

    connect = async function (opts) {        
        //this.transmitter = new WebBleMidiTransmitter();
    }

    userConnect = async function () {        
        let result = await this.transmitter.connect();
        this.connected = true;
        return result;
    }

    userDisconnect= async function () {        
        this.transmitter.disconnect();
        this.connected = false;
    }


    recordCtxStartTime = () => {
        this.plugin = this.beginSend;
        this.ctxStartTime = window.performance.now() / 1000
        this.transmitter.readyBLEpacket.clear();
    }
}

var plugin = new WebBleMidiTransmitterPlugin();

root.API["BleMIDI"] = {
    root: root,
    enabled: true,
    get avaliable(){return plugin && plugin.isAvaliable},
    api: plugin
}

//console.log(root);